// extracted by mini-css-extract-plugin
export default {"card":"Card_card__7Eml9","flexContainer":"Card_flexContainer__rRnym","img":"Card_img__4CuAD","horizontalRule":"Card_horizontalRule__z+XW1"};